import { Component } from '@angular/core';
import { CommonSharedModule } from '../common/shared.module';

@Component({
  selector: 'app-notfound',
  templateUrl: './not-found.component.html',
  standalone: true,
  imports: [CommonSharedModule]
})
export class NotFoundComponent {}
